import {createContext} from 'react'

export const Mycontext = createContext(null);